import { css } from '@emotion/react';

import * as su from './styleUtils';
import * as theme from './theme';

export const title = css(su.fontSans, su.text2xl, {
	color: theme.colors.text.primary,
	fontWeight: '700',
});

export const subTitle = css(su.fontSans, su.textLg, {
	color: theme.colors.text.primary,
	fontWeight: '700',
});

export const regular = css(su.fontSans, su.textSm, {
	color: theme.colors.text.primary,
});

export const emptyLarge = css(su.fontSans, {
	color: theme.colors.text.faint,
	fontStyle: 'italic',
	fontWeight: '300',
});

export const emptySmall = css(emptyLarge, su.textSm);

// TODO: Things like flex should not be in typography styles.
export const label = css(
	su.fontSans,
	{
		color: theme.colors.text.secondary,
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-end',
	},
	su.textLabelSize
);

export const placeholder = css(su.fontSans, {
	color: theme.colors.text.hint,
});

export const inputText = css(su.fontSans, {
	color: theme.colors.text.primary,
});

export const inputHelper = css(regular, su.textXs, su.fontInputHelper, {
	color: theme.colors.input.adornment,
	fontWeight: '300',
});

export const clickableLink = css(su.fontSans, {
	cursor: 'pointer',
	color: theme.colors.palettes.primary.main,
	'&:hover': css({ textDecoration: 'underline' }),

	'&:disabled, &[data-disabled=true]': css({
		color: theme.colors.action.disabledBackground,
		cursor: 'default',
	}),

	'&[data-read-only=true]': css({
		color: theme.colors.text.primary,
		cursor: 'default',
		textDecoration: 'none',
	}),
});

export const count = css(su.fontSans, su.textXs, {
	color: theme.colors.text.hint,
});

export const warning = css({
	color: theme.colors.toasts.warning,
	fontStyle: 'italic',
});

export const removed = css({
	textDecoration: 'line-through',
	color: theme.colors.text.errorText,
});
